import ShareRegistryPage from './share-registry-page'

export default ShareRegistryPage
